"use strict";

const UserConfiguration = function () {
  const stringKey = "user-configuration";
  const tabHeader = "2N User";

  var _onImpersonateRoleInput = function (e, value) {
    const $permissionsFieldset = $("#assessment-modal").find(".impersonate-inspection-permissions");
    if (value === "field-personnel") {
      $permissionsFieldset.removeClass("hidden");
    } else {
      $permissionsFieldset.addClass("hidden");
    }
  };

  var loadListeners = function (data) {
    $("#assessment-modal").on(
      "2N:FormInput",
      "[name='userConfiguration[impersonateRole]']",
      _onImpersonateRoleInput,
    );
  };

  var unloadListeners = function () {
    $("#assessment-modal").off(
      "2N:FormInput",
      "[name='userConfiguration[impersonateRole]']",
      _onImpersonateRoleInput,
    );
  };

  var getProps = function (data) {
    const userConfig = data.userConfiguration ?? {};
    return {
      roleOptions: (ToolSettings.getDomainOptions("user_roles") || []).filter(
        (option) => option.value !== "server",
      ),
      allInspectionPermissions: userConfig.allInspectionPermissions ?? [],
      impersonateInspectionPermissions: new Set(userConfig.impersonateInspectionPermissions ?? []),
    };
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
  };
};

module.exports = UserConfiguration();

const ToolSettings = require("../toolSettings");
